export default __webpack_public_path__ + "static/media/backgroundDark.9999590d.png";